export default {
  myDevices: {
    title: 'profile_my_devices_title',
    subtitle: 'profile_my_devices_subtitle',
    important: 'profile_my_devices_important',
    rule1: 'profile_my_devices_rule_1',
    rule2: 'profile_my_devices_rule_2',
    rule3: 'profile_my_devices_rule_3',
    logout: {
      title: 'logout_myDevices_title_label',
      label: 'logout_myDevices_description_label',
      button: 'logout_myDevices_refresh_button_redirect',
      enable: 'all_devices_logout',
    },
  },
};
